import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import LoginPage from './js/LoginPage.js';
import { useAuth } from './providers/AuthProvider';
import Dailer from './js/Dailer.js';
import SsoAuthCallback from './js/SsoAuthCallback.js';
import {
  Route,
  Routes,
} from 'react-router-dom';

function MainComponent(props) {
  const { isLoggedIn } = useAuth();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isEditable, setIsEditable] = useState(true);
  const [encryptPhoneNumber, setEncryptPhoneNumber] = useState(false);
  const [externalId, setExternalId] = useState("");
   
  useEffect(()=>{
    window.addEventListener("message", (event) => {
      if (event.data.action === "setPhoneNumber") {
        const number = event.data?.phoneNumber?.slice(-10);
        setPhoneNumber(number);
        if(event.data.uniqueId) {
          setExternalId(event.data.uniqueId)
        }
        if(event.data.edit === false) {
          setIsEditable(event.data.edit);
        }
        if(event.data.edit === undefined || event.data.edit === true) {
          setIsEditable(true);
        } 
        if(event.data.encrypt === true) {
          setEncryptPhoneNumber(event.data.encrypt);
        } 
        if(event.data.encrypt === undefined || event.data.encrypt === false) {
          setEncryptPhoneNumber(false);
        }
        if(event.data.encrypt === true && (event.data.edit === undefined || event.data.edit === true || isEditable === true)) {
          setIsEditable(false);
        }
        console.log("Phone Number Received in Iframe:", event.data.phoneNumber);
      }
    }, false);
    return () => {
      window.removeEventListener('message', ()=>{
        console.log("removing message listern")
      });
    }
  },[])  

  return (
     <Routes>
      <Route path="/auth/google/callback" element={<SsoAuthCallback />} />
      <Route
        path="*"
        element={
          !isLoggedIn ? (
            <LoginPage />
          ) : localStorage.getItem('doosra-biz-user-role') === 'USER' ? (
            <Dailer 
              numberFromIframe={phoneNumber} 
              isEditable={isEditable}
              encryptPhoneNumber={encryptPhoneNumber}
              externalId={externalId}
            />
          ) : (
            <div>Unknown Role</div>
          )
        }
      />
    </Routes>
  );
}

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, {})(MainComponent);
